export class ArrayBufferToJsonConverter {
  // for more information see: https://stackoverflow.com/questions/6965107/converting-between-strings-and-arraybuffers

  static convertArrayBufferToJson(buffer: ArrayBuffer): any {
    const decoder = new TextDecoder('utf-8');
    const str = decoder.decode(buffer);
    return JSON.parse(str);
  }

  static convertJsonToArrayBuffer(json: any): ArrayBuffer {
    const encoder = new TextEncoder(); // defaults to utf-8
    const str = JSON.stringify(json);
    const array = encoder.encode(str);
    return array.buffer;
  }
}
